export default __webpack_public_path__ + "static/media/magento-negative.d595e339.svg";